import { renderAuthoredNarrativeBundle } from './authoredNarrativeRender';
import { shouldPublishAuthoredMethodology } from './authoredNarrativeLoader';
import {
  buildRaceCompositionFacts,
  buildSexWorkplaceFacts,
  type RaceCompositionFacts,
  type SexWorkplaceFacts,
} from './peoplePopulationTrendsNarrativeFacts';

const CHART_ID = 'population_employment_trends';

export type PopulationTrendViewId = 'by_sex' | 'by_race' | 'by_race_pie';

function sexTokens(f: SexWorkplaceFacts, locationName: string): Record<string, string> {
  return {
    locationName,
    latestYear: f.latestYear != null ? String(f.latestYear) : '—',
    femaleWorkers: f.femaleWorkers != null ? f.femaleWorkers.toLocaleString() : '—',
    maleWorkers: f.maleWorkers != null ? f.maleWorkers.toLocaleString() : '—',
    femaleShare: f.femaleShare != null ? f.femaleShare.toFixed(1) : '—',
    displayGeographyName: f.displayGeographyName,
    geographyCoverageSentence: f.geographyCoverageSentence,
    trendSentence: f.trendSentence,
  };
}

function raceTokens(f: RaceCompositionFacts, locationName: string): Record<string, string> {
  return {
    locationName,
    latestYear: f.latestYear != null ? String(f.latestYear) : '—',
    populationUniverseLabel: f.populationUniverseLabel,
    largestRaceLabel: f.largestRaceLabel ?? '—',
    largestRaceShare: f.largestRaceShare != null ? f.largestRaceShare.toFixed(1) : '—',
    secondRaceSentence: f.secondRaceSentence,
    thirdRaceSentence: f.thirdRaceSentence,
    largestShareChangeSentence: f.largestShareChangeSentence,
  };
}

export function buildPopulationTrendsAuthoredBundle(
  view: PopulationTrendViewId,
  params: {
    locationName: string;
    sexFacts?: SexWorkplaceFacts;
    raceFacts?: RaceCompositionFacts;
  }
) {
  const viewId = view === 'by_race_pie' ? 'by_race_pie' : view;
  const tokens =
    view === 'by_sex'
      ? sexTokens(params.sexFacts ?? buildSexWorkplaceFacts({
          locationName: params.locationName,
          sexSeries: [],
          isUsingCountyData: false,
          countyName: null,
        }), params.locationName)
      : raceTokens(
          params.raceFacts ??
            buildRaceCompositionFacts({
              locationName: params.locationName,
              compositionSeries: [],
              chartShareByRaceYear: new Map(),
              raceLabelMap: {},
            }),
          params.locationName
        );

  const bundle = renderAuthoredNarrativeBundle(CHART_ID, viewId, tokens);
  if (!shouldPublishAuthoredMethodology(bundle.authoringStatus)) {
    bundle.methodology = undefined;
  }
  return bundle;
}
